import React from 'react'
import ThemeProvider from './src/theme/default'

export const wrapRootElement = ({ element }) => (
  <ThemeProvider>{element}</ThemeProvider>
)
